import request from "@/utils/http"
import store from "@/store"

// 获取 Excel 导出模板（单个）
export function getExcelTemplate(templateId) {
  return request.get(`/sheet/excelTemplate/${templateId}`).commonDeal()
}

// 获取 Excel 导出模板（列表）
export function getExcelTemplateList(appId, sheetId = "all", refSheetId = "") {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  const params = { appId, sheetId }
  if (refSheetId) params.refSheetId = refSheetId
  return request.get(`/sheet/excelTemplates`, { params }).commonDeal()
}

/**
 * @param excelTemplate 结构参考列表中的结构
 * @returns {*}
 */
// 创建 Excel 导出模板
export function createExcelTemplate(excelTemplate, appId) {
  return request.post(`/sheet/excelTemplate`, excelTemplate, { params: { appId } }).commonDeal()
}

// 删除 Excel 导出模板
export function deleteExcelTemplate(templateId) {
  return request.post(`/sheet/excelTemplate/delete/${templateId}`).commonDeal()
}

/**
 * @param excelTemplate 需要指定id
 * @returns {*}
 */
// 更新 Excel 导出模板
export function updateExcelTemplate(excelTemplate) {
  return request.post(`/sheet/excelTemplate/update`, excelTemplate).commonDeal()
}
